<template>
  <CommonPage :page="errorPage" />
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType } from 'vue';

import CommonPage from '@/components/CommonPage.vue';
import { useActions } from '@/hooks/use_actions';
import { useDisabledContents } from '@/hooks/use_disabled_contents';
import { useMileage } from '@/hooks/use_mileage';
import { ContentTextEditorModel } from '@/models/content_text_editor_model';
import { Page } from '@/models/page';
import { Style } from '@/models/style';
import RouterConst from '@/router/router_const';

const defaultPage = new Page({
  path: RouterConst.Error,
  contents: [
    new ContentTextEditorModel({
      text: '処理を中断しました。しばらく経ってから 再度 実行してください。',
      style: new Style({ textAlign: 'center' }),
    }),
  ],
});

export default defineComponent({
  name: 'ErrorPage',
  components: { CommonPage },
  props: {
    page: {
      type: Object as PropType<Page>,
      default: () => undefined,
    },
  },
  setup: (props) => {
    const errorPage = props.page || defaultPage;
    const actions = useActions(errorPage.actions);
    const { getMileage, isMileageContent } = useMileage();
    const { shouldVerifyDisablement, getDisabledContents } = useDisabledContents();
    const hasMileage = errorPage.contents.find(content => isMileageContent(content.typeKbn));
    const hasDisablement = errorPage.contents.find(content => shouldVerifyDisablement(content.id));
    onMounted(async () => {
      await actions();

      // マイレージポイント表示、マイレージポイント履歴表示のため
      if (hasMileage) {
        await getMileage();
      }

      // 非活性コンテンツを取得する
      if (hasDisablement) {
        await getDisabledContents();
      }
    });

    return {
      errorPage,
    };
  },
});
</script>
